import { useEffect, useState } from "react";
import axios from "axios";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { useTranslation } from "react-i18next";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png", iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png", shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png" });
const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
const pin = L.divIcon({
  className: "nolena-pin",
  html: `<span class="nolena-pin__shape" aria-hidden="true">
    <svg class="nolena-pin__paw" viewBox="0 0 24 24" focusable="false">
      <circle cx="7" cy="7" r="2.2" />
      <circle cx="12" cy="5.5" r="2.2" />
      <circle cx="17" cy="7" r="2.2" />
      <path d="M12 10c-3.4 0-6 2.5-6 5.1 0 2 1.5 3.4 3.4 3.4 1 0 1.7-.4 2.6-.4s1.6.4 2.6.4c1.9 0 3.4-1.4 3.4-3.4C18 12.5 15.4 10 12 10Z" />
    </svg>
  </span>`,
  iconSize: [44, 48],
  iconAnchor: [22, 46],
  popupAnchor: [0, -42],
});

function MapZoomLock() {
  const map = useMap();

  useEffect(() => {
    map.scrollWheelZoom.disable();
    map.doubleClickZoom.disable();
    map.touchZoom.disable();
    map.keyboard.disable();
    map.boxZoom.disable();

    const container = map.getContainer();
    const preventTrackpadPinch = (event) => {
      if (event.ctrlKey || event.metaKey) event.preventDefault();
    };
    const preventGestureZoom = (event) => event.preventDefault();

    container.addEventListener("wheel", preventTrackpadPinch, { passive: false });
    container.addEventListener("gesturestart", preventGestureZoom, { passive: false });
    container.addEventListener("gesturechange", preventGestureZoom, { passive: false });

    return () => {
      container.removeEventListener("wheel", preventTrackpadPinch);
      container.removeEventListener("gesturestart", preventGestureZoom);
      container.removeEventListener("gesturechange", preventGestureZoom);
    };
  }, [map]);

  return null;
}

export const DealerMap = () => {
  const [dealers, setDealers] = useState([]);
  const { t } = useTranslation();
  useEffect(() => { axios.get(`${API}/dealers`).then(({ data }) => setDealers(data.dealers)).catch(() => undefined); }, []);
  return <section id="bayiler" className="bg-surface py-24 lg:py-32"><div className="mx-auto max-w-7xl px-5 sm:px-8"><span className="text-xs font-semibold uppercase tracking-[.2em] text-brand">{t("map.eyebrow")}</span><h2 className="mt-4 font-heading text-3xl font-bold sm:text-5xl">{t("map.title")}</h2><p className="mt-4 max-w-xl text-ink/65">{t("map.text")}</p><div className="nolena-map relative z-0 isolate mt-10 overflow-hidden rounded-3xl border border-detail"><MapContainer center={[41.02, 28.95]} zoom={10} scrollWheelZoom={false} doubleClickZoom={false} touchZoom={false} keyboard={false} zoomControl className="h-[430px] w-full"><MapZoomLock /><TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>' maxZoom={20} />{dealers.map((dealer) => <Marker key={dealer.id} icon={pin} position={[dealer.latitude, dealer.longitude]}><Popup><b>{dealer.name}</b><br />{dealer.address}<br /><a href={`tel:${dealer.phone.replaceAll(" ", "")}`}>{dealer.phone}</a></Popup></Marker>)}</MapContainer></div><div className="mt-5 grid gap-3 sm:grid-cols-2">{dealers.map((dealer) => <div key={dealer.id} className="rounded-2xl border border-detail bg-cream p-4"><b>{dealer.name}</b><p className="mt-1 text-sm text-ink/60">{dealer.address}</p></div>)}</div></div></section>;
};
